module.exports = __webpack_public_path__ + "img/zh-431ee0.png";